import ExtendedSpine from "slotworks/graphics/spine/spine";
import Contract from "slotworks/utils/contract";
import Layers from "slotworks/graphics/layers/layers";
import soundManager from "slotworks/sound/sound-manager";

export default class LeprechaunComponent {

    private spine: ExtendedSpine;

    private winCount: number = 0;

    constructor() {
        this.spine = Layers.Custom.get("Leprechaun").getSpine("leprechaun");
    }

    public sayHello(): Contract<void> {
        return new Contract(resolve => {
            soundManager.customEvent("voice_hello");
            this.spine.play(0, LeprechaunAnimations.HELLO, false);
            this.setListener(resolve);
        });
    }

    public noWin() {
        return new Contract(resolve => {
            this.spine.play(0, LeprechaunAnimations.NOWIN, false);
            this.setListener(resolve);
        });
    }

    public win() {
        return new Contract(resolve => {
            this.winCount++;
            if(this.winCount <= 3) {
                soundManager.customEvent("voice_laugh" + this.winCount);
            } else {
                const rand = Math.floor(1 + Math.random() * 3);
                soundManager.customEvent("voice_laugh" + rand);
            }
            this.spine.play(0, LeprechaunAnimations.WIN1, false);
            this.setListener(resolve);
        });
    }

    public extraChance() {
        return new Contract(resolve => {
            soundManager.customEvent("leprechaun_coin_toss");
            this.spine.play(0, LeprechaunAnimations.EXTRA_CHANCE, false);
            this.setListener(resolve);
        });
    }

    private idle() {
        this.spine.play(0, LeprechaunAnimations.IDLE, true);
    }

    private setListener(resolve: Function) {
        this.spine.state.tracks[0].listener = {
            complete: () => {
                this.cleanSpine();
                this.idle();
                resolve(null);
            }
        }
    }

    private cleanSpine() {
        if(this.spine.state.tracks && this.spine.state.tracks[0] && this.spine.state.tracks[0].listener) {
            this.spine.state.tracks[0].listener.complete = null;
        }
        this.spine.state.clearTracks();
        this.spine.state.tracks = [];
    }

}

enum LeprechaunAnimations {
    IDLE = "leprechaun_idle",
    HELLO = "leprechaun_hello",
    EXTRA_CHANCE = "leprechaun_extra_chance",
    NOWIN = "leprechaun_noWin",
    WIN1 = "leprechaun_win_1",
    WIN2 = "leprechaun_win_2",
}


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/components/respin/leprechaun-component.ts